import React from 'react';
import {withStyles} from '@material-ui/core/styles/index';
import classNames from 'classnames';

const styles = theme => ({
    root: {},
    footText:{
        textAlign:"right",
        width:'100%'
    }
});

function MainFooter({classes})
{
    return (
        <div className={classNames(classes.root, "flex flex-1 text-right px-24")}>
            <div className={classes.footText}>&copy; Copyright 2018 Dutch Caribbean Stock Exchange</div>
        </div>
    );
}

export default withStyles(styles, {withTheme: true})(MainFooter);


// WEBPACK FOOTER //
// ./src/main/MainFooter.js